import ContactActions from './ContactActions';
import Ornament from './Ornament';

export default function CtaBand({
  title = 'Hit a wall in your family history? Let’s get you moving again.',
  text = 'A patient technician is in live chat right now — no waiting on hold, no jargon, no rush.',
}) {
  return (
    <section className="cta-band">
      <div className="container cta-band__inner">
        <Ornament light />
        <div>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <ContactActions light />
      </div>
    </section>
  );
}
